import { render, staticRenderFns } from "./TrustedHeader.vue?vue&type=template&id=7fc5152c&"
import script from "./TrustedHeader.vue?vue&type=script&lang=ts&"
export * from "./TrustedHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports